import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';
import getFCMToken from './GetFCMToken';
import { requestPermission } from './CheckPermission';
import subscribeTokenToTopic from './SubscribeToTopic';

const firebaseConfig = {
  apiKey: "AIzaSyBedMV6LQBxy9tfoqJf5649N778AAg7bzo",
  authDomain: "pentalens-99aa0.firebaseapp.com",
  projectId: "pentalens-99aa0",
  storageBucket: "pentalens-99aa0.appspot.com",
  messagingSenderId: "613886836150",
  appId: "1:613886836150:web:2bcdf571b06ef0aafc1517",
  measurementId: "G-CN9DKDL5SJ"
};
// const [notification, setNotification] = useState(null);

const app = initializeApp(firebaseConfig);

const messaging = getMessaging(app);

export const initNotifications = async () => {
  try {
    // First step: Check Permission
    const permission = await requestPermission();

    if (permission) {
      // Second step: Get FCM Token
      const currentToken = await getFCMToken(messaging);

      // Third step: Subscribe To Topic
      const subscribeStatus = await subscribeTokenToTopic(currentToken, 'pentalens-channel');

      if (subscribeStatus) {
        console.log('Notifications initialized successfully.');
      } else {
        console.log('Failed to subscribe to the notification topic.');
      }

    } else {
      console.log('Permission not granted for notifications.');
    }
  } catch (error) {
    console.error('Error initializing notifications:', error);
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    // Assuming 'messaging' is your Firebase messaging instance
    onMessage(messaging, (payload) => {
      console.log("payload", payload);
      // const { title, body } = payload.notification;
      // setNotification({ title, body });
      resolve(payload);
    });
  });

